/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {DeleteTimecardRequest} from '@cash-web/protos/squareup/timecards/timecards_service.pb'
import {DeleteTimecardResponse} from '@cash-web/protos/squareup/timecards/timecards_service.pb'


export const deleteTimecard = (request: DeleteTimecardRequest, options?: CashRequestOptions) => post<DeleteTimecardRequest, DeleteTimecardResponse>("/proxy/services/squareup.timecards.PublicTimecardsService/DeleteTimecard", request, {...options, rejectOnError: true })